import Vue from 'vue'
import toastr from '../toastr'
import VueResource from 'vue-resource'
import Multiselect from '../../component/multiselect.vue'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '../mixins.js'
import datePicker from '../../component/datePicker.vue'
import checkbox from '../../component/dccore-form/checkbox.vue'
import moment from 'moment'
import 'moment/locale/pl'

if ($('#old_assign_team_form').length) {
  Vue.use(VueResource)
  new Vue({
    el: '#old_assign_team_form',
    components: {
      RingLoader,
      datePicker,
      Multiselect,
      checkbox
    },
    mixins: [mixins],
    data: {
      loading: 0,
      search: {
        date: moment().locale('pl').format('YYYY-MM-DD'),
        brands: [],
        merge: false,
      },
      brands: [],
      meals: [],
      teams: [],
      showTeams: [],
      errors: {},
      isSearch: false,
      selectedMeals: [],
      assignedMeals: {},
      merged: null,
      blockMerge: false,
      blockButtons: false,

    },
    watch: {
      'search.date' : function() {
        this.setSearchView()
      }
    },
    mounted: function () {
      this.setSearchView()
      this.loading++
      this.getBrands()
      this.getTeams()
      this.loading--
    },
    methods: {
      changeCheckMeal(index) {
        let id = this.getMealIdentificator(index)
        let checkedIndex = this.selectedMeals.indexOf(id)

        if (checkedIndex > -1) {
          this.selectedMeals.splice(checkedIndex, 1)
          return
        }

        this.selectedMeals.push(this.getMealIdentificator(index))
      },
      checkMealTree(index) {
        let depth = this.meals[index].depth
        let check = !this.isCheckedMealByIndex(index)

        this.checkSingleMeal(index, check)

        for (let i = index + 1 ; i < this.meals.length ; i++ ) {
          if (this.meals[i].depth <= depth ) {
            break
          }

          this.checkSingleMeal(i, check)
        }
      },
      checkSingleMeal(index, check = true) {
        let id = this.getMealIdentificator(index)
        let checkedIndex = this.selectedMeals.indexOf(id)
        let isChecked = checkedIndex > -1

        if (isChecked && !check) {
          this.selectedMeals.splice(checkedIndex, 1)
          return
        }

        if (!isChecked && check) {
          if (!this.isAssignedToTeam(id, true)) {
            this.selectedMeals.push(this.getMealIdentificator(index))
          }
        }

      },
      isCheckedMealByIndex(index) {
        let id = this.getMealIdentificator(index)
        let checkedIndex = this.selectedMeals.indexOf(id)

        return checkedIndex > -1
      },
      getMealIdentificator(index) {
        return this.merged ? this.meals[index].mealId : this.meals[index].uid
      },
      getBrands() {
        this.loading++
        let url = Routing.generate('api_get_brands', { context: 'dropdown' })

        Vue.http.get(url).then(response => {
          this.brands = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getTeams() {
        this.loading++
        let url = Routing.generate('api_get_active_production_teams', { context: 'dropdown',
          'date': this.search.date })

        Vue.http.get(url).then(response => {
          this.showTeams = new Array(response.data.length).fill(false)
          this.teams = response.data

          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getAssignedMeals() {
        let url = Routing.generate('api_get_assign_teams', { date: this.search.date })

        Vue.http.get(url).then(response => {
          this.assignedMeals = response.data
        }, response => {
          this.handleAjaxError(response)
        })
      },
      searchMealsFromProductionList() {

        let url = Routing.generate('api_post_assign_team_by_date_group_meal')
        this.loading++
        this.selectedMeals = []
        Vue.http.post(url, { 'data': this.search })
          .then(response => {
            this.meals = response.data
            this.loading--
            this.isSearch = true
            this.merged = this.search.merge
            this.getTeams()
            this.getAssignedMeals()
          }, response => {
            this.handleAjaxError(response)
            this.loading--
          })
      },
      getUnitName(unit) {
        return unit === 'mass' ?
          Translator.trans('material.entity.units.kg') :
          Translator.trans('material.entity.units.piece')
      },
      assignToTeam(teamId) {
        this.blockButtons = true
        let url = Routing.generate('api_post_assign_team', { 'id': teamId })

        Vue.http.post(url, { 'data': this.generateDataToSend(),
          'date': this.search.date })
          .then(() => {
            toastr.success(Translator.trans('assign_team.flash.assigned'))
            this.getAssignedMeals()
            this.setSearchView()
            this.selectedMeals = []
            this.blockButtons = false
          }, response => {
            this.handleAjaxError(response)
          })
      },
      generateDataToSend() {
        let merged = this.merged
        return Object.values(this.meals).filter( product => {
          return this.selectedMeals.indexOf( merged ? product.mealId : product.uid ) > -1
        })
      },
      isAssignedToTeam(id, tree = false) {
        let assigned = false
        Object.values(this.assignedMeals).forEach(team => {
          Object.values(team).forEach(meal => {
            if (tree && meal.uid === id) {
              assigned = true
            } else if (meal.mealId === id) {
              assigned = true
            }
          }
          )
        })
        return assigned
      },
      removeAssignedMeal(id) {
        let url = Routing.generate('api_remove_assign_team', { 'id': id })

        Vue.http.delete(url)
          .then(() => {
            toastr.success(Translator.trans('assign_team.flash.removed'))
            this.getAssignedMeals()
            this.setSearchView()
          }, response => {
            this.handleAjaxError(response)
          })
      },
      changePriority(uid, event) {
        let priority = event.target.value
        let url = Routing.generate('api_post_assign_team_change_priority', { 'uid': uid })

        Vue.http.post(url, { 'date': this.search.date,
          'priority': priority })
          .then(() => {
            toastr.success(Translator.trans('assign_team.flash.priority_change'))
            this.getAssignedMeals()
          }, response => {
            this.handleAjaxError(response)
          })
      },
      setSearchView() {
        let url = Routing.generate('api_get_assign_team_assigned_team_tree_view', { 'date': this.search.date })

        Vue.http.get(url)
          .then(response => {
            if (response.data) {
              this.blockMerge = true
              this.search.merge = response.data.merge
            } else {
              this.blockMerge = false
            }
          })
      },
      translateType(name) {
        return Translator.trans(`assign_team.types.${name}`)
      },
      showTeam(i) {
        this.showTeams[i] = !this.showTeams[i]
        this.$forceUpdate()
      }

    }
  })
}
